import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { useOrderStatus } from 'hooks/order-status';
import { DetailsModalWrapper } from 'pages/account/account-orders/details-modal/details-modal-wrapper';
import DeliveryConfirmation from 'pages/order-confirmation/delivery/delivery-confirmation';
import { OrderSuccessFailureStatuses } from 'state/order/constants';

const IsEnRouteModal: React.FC<React.PropsWithChildren<{
  rbiOrderId: string;
  onModalDismiss: (orderId: string) => void;
}>> = ({ rbiOrderId, onModalDismiss }) => {
  const { serverOrder } = useOrderStatus({
    failureStatuses: OrderSuccessFailureStatuses.failures,
    rbiOrderId,
    successStatuses: OrderSuccessFailureStatuses.success,
    skip: false,
  });

  // TODO: ReactNavigation GST-92 Move away from Modal component
  return (
    <DetailsModalWrapper
      onDismiss={() => onModalDismiss('')}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Order Details',
      }}
    >
      {serverOrder && (
        <ScrollView>
          <DeliveryConfirmation serverOrder={serverOrder} />
        </ScrollView>
      )}
    </DetailsModalWrapper>
  );
};

export default IsEnRouteModal;
